import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiThumbsUp({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 14 13"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.88353 0.429915C5.97715 0.219257 6.18606 0.0834961 6.41659 0.0834961C7.03542 0.0834961 7.62892 0.329329 8.0665 0.766914C8.50409 1.2045 8.74992 1.79799 8.74992 2.41683V4.16683H11.4653C11.7177 4.16449 11.9677 4.2168 12.198 4.32018C12.4295 4.42406 12.6356 4.57701 12.802 4.76844C12.9685 4.95987 13.0913 5.18521 13.1621 5.42884C13.2328 5.67246 13.2497 5.92856 13.2116 6.17937L12.4067 11.4293C12.4066 11.4294 12.4067 11.4291 12.4067 11.4293C12.3433 11.8464 12.1313 12.227 11.8098 12.5003C11.4891 12.7729 11.081 12.9207 10.6602 12.9168H2.33325C1.86912 12.9168 1.424 12.7325 1.09582 12.4043C0.767626 12.0761 0.583252 11.631 0.583252 11.1668V7.0835C0.583252 6.61937 0.767626 6.17425 1.09582 5.84606C1.424 5.51787 1.86912 5.3335 2.33325 5.3335H3.70416L5.88353 0.429915ZM4.66659 6.04062L6.77115 1.30535C6.94696 1.36143 7.10864 1.45896 7.24154 1.59187C7.46034 1.81066 7.58325 2.10741 7.58325 2.41683V4.75016C7.58325 5.07233 7.84442 5.3335 8.16659 5.3335H11.4683L11.4749 5.33346C11.5594 5.3325 11.6432 5.34994 11.7203 5.38456C11.7975 5.41919 11.8662 5.47017 11.9216 5.53398C11.9771 5.5978 12.0181 5.67291 12.0417 5.75412C12.0652 5.83525 12.0709 5.92053 12.0582 6.00406C12.0582 6.00414 12.0582 6.00398 12.0582 6.00406L11.2532 11.2544C11.2321 11.3935 11.1614 11.5203 11.0542 11.6114C10.947 11.7025 10.8105 11.7518 10.6698 11.7502L4.66659 11.7502V6.04062ZM3.49992 11.7502V6.50016H2.33325C2.17854 6.50016 2.03017 6.56162 1.92077 6.67102C1.81138 6.78041 1.74992 6.92879 1.74992 7.0835V11.1668C1.74992 11.3215 1.81138 11.4699 1.92077 11.5793C2.03017 11.6887 2.17854 11.7502 2.33325 11.7502H3.49992Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiThumbsUp;
